var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_94",
    "data-name": "Gruppe 94",
    transform: "translate(-743 -1790)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    transform: "translate(743 1790)",
    fill: "#fff",
    stroke: "#31c485",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5,
    cy: 35,
    rx: 35.5,
    ry: 35,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5,
    cy: 35,
    rx: 35,
    ry: 34.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_646",
    "data-name": "Pfad 646",
    d: "M1231.721,419.142l9.34,11.55,14.487-14.392,6.586-6.542",
    transform: "translate(-468.427 1404.775)",
    fill: "none",
    stroke: "#31c485",
    strokeLinecap: "round",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorrect);
export default __webpack_public_path__ + "static/media/IconCorrect.3b0edf32a98bf4efd5cacd589109edb3.svg";
export { ForwardRef as ReactComponent };